export type UserRow = {
  id: number;
  name: string;
  email: string;
  codcli: string | null;
  tipo: string | null;
  estado: string | null;
};

export type PermDetail = {
  user: UserRow;
  roles: string[];
  permissions_direct: string[];
  permissions_all: string[];
};

export type PermCatalogRow = {
  id: number;
  name: string;
  guard_name: string;
};

export type PermisosState = {
  loadingUsers: boolean;
  loadingPerms: boolean;
  loadingDetail: boolean;
  saving: boolean;

  errorMessage: string | null;

  users: UserRow[];
  permsCatalog: string[];

  detail: PermDetail | null;
};

export default function state(): PermisosState {
  return {
    loadingUsers: false,
    loadingPerms: false,
    loadingDetail: false,
    saving: false,
    errorMessage: null,

    users: [],
    permsCatalog: [],

    detail: null,
  };
}